import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const RatingWrapper = styled.div<{ $bgColor: string }>`
  padding: 4px 8px;
  ${borderRadius.r2}
  background-color: ${({ $bgColor }) => $bgColor};
  width: fit-content;
  height: fit-content;
`;

export const RatingLabel = styled.span<{ $textColor: string }>`
  ${typographyV2.titleXs};
  color: ${({ $textColor }) => $textColor};
`;
